export function closeDropdownFromElementWithin(element: HTMLElement) {
  const parentDetails = element.closest('details');

  if (parentDetails instanceof HTMLDetailsElement) {
    // Defer to the next event loop
    //
    // There's a bug on Chrome Mobile (also reproducible on Chrome desktop simulating mobile)
    // where clicking the `search` button on the page header mobile search menu
    // causes Chrome to crash.
    setTimeout(() => {
      parentDetails.open = false;
    });
  }
}
